var map = {
	"./": [
		279
	],
	"./Dividends": [
		432,
		0,
		1,
		2,
		4,
		25
	],
	"./Dividends/": [
		432,
		0,
		1,
		2,
		4,
		25
	],
	"./Dividends/Dividends": [
		742,
		0,
		1,
		2,
		4,
		37
	],
	"./Dividends/Dividends.route": [
		444
	],
	"./Dividends/Dividends.route.tsx": [
		444
	],
	"./Dividends/Dividends.styled": [
		718,
		79
	],
	"./Dividends/Dividends.styled.tsx": [
		718,
		79
	],
	"./Dividends/Dividends.tsx": [
		742,
		0,
		1,
		2,
		4,
		37
	],
	"./Dividends/components/Allocate": [
		719,
		0,
		4,
		44
	],
	"./Dividends/components/Allocate.styled": [
		700,
		65
	],
	"./Dividends/components/Allocate.styled.tsx": [
		700,
		65
	],
	"./Dividends/components/Allocate.tsx": [
		719,
		0,
		4,
		44
	],
	"./Dividends/components/CustomCountdown": [
		721,
		77
	],
	"./Dividends/components/CustomCountdown.tsx": [
		721,
		77
	],
	"./Dividends/components/Deallocate": [
		720,
		0,
		4,
		45
	],
	"./Dividends/components/Deallocate.styled": [
		701,
		66
	],
	"./Dividends/components/Deallocate.styled.tsx": [
		701,
		66
	],
	"./Dividends/components/Deallocate.tsx": [
		720,
		0,
		4,
		45
	],
	"./Dividends/index": [
		432,
		0,
		1,
		2,
		4,
		25
	],
	"./Dividends/index.tsx": [
		432,
		0,
		1,
		2,
		4,
		25
	],
	"./EcosystemPartners": [
		323,
		11,
		22
	],
	"./EcosystemPartners/": [
		323,
		11,
		22
	],
	"./EcosystemPartners/EcosystemPartners": [
		743,
		11
	],
	"./EcosystemPartners/EcosystemPartners.route": [
		445
	],
	"./EcosystemPartners/EcosystemPartners.route.tsx": [
		445
	],
	"./EcosystemPartners/EcosystemPartners.styled": [
		744,
		57
	],
	"./EcosystemPartners/EcosystemPartners.styled.tsx": [
		744,
		57
	],
	"./EcosystemPartners/EcosystemPartners.tsx": [
		743,
		11
	],
	"./EcosystemPartners/index": [
		323,
		11,
		22
	],
	"./EcosystemPartners/index.ts": [
		323,
		11,
		22
	],
	"./LPPosition": [
		433,
		0,
		1,
		2,
		3,
		24
	],
	"./LPPosition/": [
		433,
		0,
		1,
		2,
		3,
		24
	],
	"./LPPosition/LPPosition": [
		738,
		0,
		1,
		2,
		3,
		33
	],
	"./LPPosition/LPPosition.route": [
		446
	],
	"./LPPosition/LPPosition.route.tsx": [
		446
	],
	"./LPPosition/LPPosition.styled": [
		722,
		88
	],
	"./LPPosition/LPPosition.styled.tsx": [
		722,
		88
	],
	"./LPPosition/LPPosition.tsx": [
		738,
		0,
		1,
		2,
		3,
		33
	],
	"./LPPosition/components/Boost": [
		727,
		0,
		3,
		4,
		48
	],
	"./LPPosition/components/Boost.styled": [
		706,
		67
	],
	"./LPPosition/components/Boost.styled.tsx": [
		706,
		67
	],
	"./LPPosition/components/Boost.tsx": [
		727,
		0,
		3,
		4,
		48
	],
	"./LPPosition/components/CustomCountDown": [
		729,
		78
	],
	"./LPPosition/components/CustomCountDown.tsx": [
		729,
		78
	],
	"./LPPosition/components/Deposit": [
		728,
		0,
		1,
		3,
		4,
		41
	],
	"./LPPosition/components/Deposit.styled": [
		707,
		68
	],
	"./LPPosition/components/Deposit.styled.tsx": [
		707,
		68
	],
	"./LPPosition/components/Deposit.tsx": [
		728,
		0,
		1,
		3,
		4,
		41
	],
	"./LPPosition/components/LockDuration": [
		723,
		0,
		3,
		40
	],
	"./LPPosition/components/LockDuration.styled": [
		702,
		69
	],
	"./LPPosition/components/LockDuration.styled.tsx": [
		702,
		69
	],
	"./LPPosition/components/LockDuration.tsx": [
		723,
		0,
		3,
		40
	],
	"./LPPosition/components/Merge": [
		731,
		0,
		3,
		42
	],
	"./LPPosition/components/Merge.styled": [
		709,
		70
	],
	"./LPPosition/components/Merge.styled.tsx": [
		709,
		70
	],
	"./LPPosition/components/Merge.tsx": [
		731,
		0,
		3,
		42
	],
	"./LPPosition/components/RenewDuration": [
		730,
		0,
		3,
		39
	],
	"./LPPosition/components/RenewDuration.styled": [
		708,
		71
	],
	"./LPPosition/components/RenewDuration.styled.tsx": [
		708,
		71
	],
	"./LPPosition/components/RenewDuration.tsx": [
		730,
		0,
		3,
		39
	],
	"./LPPosition/components/SplitPos": [
		725,
		0,
		3,
		43
	],
	"./LPPosition/components/SplitPos.styled": [
		704,
		72
	],
	"./LPPosition/components/SplitPos.styled.tsx": [
		704,
		72
	],
	"./LPPosition/components/SplitPos.tsx": [
		725,
		0,
		3,
		43
	],
	"./LPPosition/components/TransferPos": [
		724,
		0,
		3,
		49
	],
	"./LPPosition/components/TransferPos.styled": [
		703,
		73
	],
	"./LPPosition/components/TransferPos.styled.tsx": [
		703,
		73
	],
	"./LPPosition/components/TransferPos.tsx": [
		724,
		0,
		3,
		49
	],
	"./LPPosition/components/Unboost": [
		726,
		0,
		3,
		50
	],
	"./LPPosition/components/Unboost.styled": [
		705,
		74
	],
	"./LPPosition/components/Unboost.styled.tsx": [
		705,
		74
	],
	"./LPPosition/components/Unboost.tsx": [
		726,
		0,
		3,
		50
	],
	"./LPPosition/index": [
		433,
		0,
		1,
		2,
		3,
		24
	],
	"./LPPosition/index.tsx": [
		433,
		0,
		1,
		2,
		3,
		24
	],
	"./LandingPage": [
		434,
		0,
		15,
		28
	],
	"./LandingPage/": [
		434,
		0,
		15,
		28
	],
	"./LandingPage/LandingPage": [
		758,
		0,
		15
	],
	"./LandingPage/LandingPage.hard": [
		772,
		89
	],
	"./LandingPage/LandingPage.hard.tsx": [
		772,
		89
	],
	"./LandingPage/LandingPage.route": [
		447
	],
	"./LandingPage/LandingPage.route.tsx": [
		447
	],
	"./LandingPage/LandingPage.styled": [
		747,
		90
	],
	"./LandingPage/LandingPage.styled.tsx": [
		747,
		90
	],
	"./LandingPage/LandingPage.tsx": [
		758,
		0,
		15
	],
	"./LandingPage/components/AirdopRules.styled": [
		732,
		91
	],
	"./LandingPage/components/AirdopRules.styled.tsx": [
		732,
		91
	],
	"./LandingPage/components/AirdropRules": [
		748,
		51
	],
	"./LandingPage/components/AirdropRules.tsx": [
		748,
		51
	],
	"./LandingPage/index": [
		434,
		0,
		15,
		28
	],
	"./LandingPage/index.tsx": [
		434,
		0,
		15,
		28
	],
	"./LaunchPad": [
		435,
		0,
		9,
		8,
		27
	],
	"./LaunchPad/": [
		435,
		0,
		9,
		8,
		27
	],
	"./LaunchPad/Countdown": [
		760,
		92
	],
	"./LaunchPad/Countdown.tsx": [
		760,
		92
	],
	"./LaunchPad/LaunchPad": [
		739,
		0,
		9,
		8,
		52
	],
	"./LaunchPad/LaunchPad.route": [
		448
	],
	"./LaunchPad/LaunchPad.route.tsx": [
		448
	],
	"./LaunchPad/LaunchPad.styled": [
		733,
		80
	],
	"./LaunchPad/LaunchPad.styled.tsx": [
		733,
		80
	],
	"./LaunchPad/LaunchPad.tsx": [
		739,
		0,
		9,
		8,
		52
	],
	"./LaunchPad/Launhpad.hard": [
		773,
		93
	],
	"./LaunchPad/Launhpad.hard.tsx": [
		773,
		93
	],
	"./LaunchPad/index": [
		435,
		0,
		9,
		8,
		27
	],
	"./LaunchPad/index.tsx": [
		435,
		0,
		9,
		8,
		27
	],
	"./LaunchPadDetail": [
		436,
		0,
		9,
		8,
		13,
		29
	],
	"./LaunchPadDetail/": [
		436,
		0,
		9,
		8,
		13,
		29
	],
	"./LaunchPadDetail/LaunchPad.hard": [
		774,
		56
	],
	"./LaunchPadDetail/LaunchPad.hard.tsx": [
		774,
		56
	],
	"./LaunchPadDetail/LaunchPadDetail": [
		759,
		0,
		9,
		8,
		13
	],
	"./LaunchPadDetail/LaunchPadDetail.route": [
		449
	],
	"./LaunchPadDetail/LaunchPadDetail.route.tsx": [
		449
	],
	"./LaunchPadDetail/LaunchPadDetail.styled": [
		749,
		81
	],
	"./LaunchPadDetail/LaunchPadDetail.styled.tsx": [
		749,
		81
	],
	"./LaunchPadDetail/LaunchPadDetail.tsx": [
		759,
		0,
		9,
		8,
		13
	],
	"./LaunchPadDetail/index": [
		436,
		0,
		9,
		8,
		13,
		29
	],
	"./LaunchPadDetail/index.tsx": [
		436,
		0,
		9,
		8,
		13,
		29
	],
	"./LeaderBoard": [
		324,
		0,
		1,
		12,
		23
	],
	"./LeaderBoard/": [
		324,
		0,
		1,
		12,
		23
	],
	"./LeaderBoard/LeaderBoard": [
		745,
		0,
		1,
		12
	],
	"./LeaderBoard/LeaderBoard.hard": [
		775,
		94
	],
	"./LeaderBoard/LeaderBoard.hard.tsx": [
		775,
		94
	],
	"./LeaderBoard/LeaderBoard.route": [
		450
	],
	"./LeaderBoard/LeaderBoard.route.tsx": [
		450
	],
	"./LeaderBoard/LeaderBoard.styled": [
		746,
		82
	],
	"./LeaderBoard/LeaderBoard.styled.tsx": [
		746,
		82
	],
	"./LeaderBoard/LeaderBoard.tsx": [
		745,
		0,
		1,
		12
	],
	"./LeaderBoard/index": [
		324,
		0,
		1,
		12,
		23
	],
	"./LeaderBoard/index.tsx": [
		324,
		0,
		1,
		12,
		23
	],
	"./Liquidity": [
		325,
		0,
		1,
		2,
		3,
		19
	],
	"./Liquidity/": [
		325,
		0,
		1,
		2,
		3,
		19
	],
	"./Liquidity/Liquidity": [
		736,
		0,
		1,
		2,
		3,
		34
	],
	"./Liquidity/Liquidity.hard": [
		776,
		95
	],
	"./Liquidity/Liquidity.hard.tsx": [
		776,
		95
	],
	"./Liquidity/Liquidity.route": [
		451
	],
	"./Liquidity/Liquidity.route.tsx": [
		451
	],
	"./Liquidity/Liquidity.styled": [
		712,
		58
	],
	"./Liquidity/Liquidity.styled.tsx": [
		712,
		58
	],
	"./Liquidity/Liquidity.tsx": [
		736,
		0,
		1,
		2,
		3,
		34
	],
	"./Liquidity/components/Unbind": [
		713,
		0,
		1,
		2,
		7,
		46
	],
	"./Liquidity/components/Unbind.styled": [
		697,
		75
	],
	"./Liquidity/components/Unbind.styled.tsx": [
		697,
		75
	],
	"./Liquidity/components/Unbind.tsx": [
		713,
		0,
		1,
		2,
		7,
		46
	],
	"./Liquidity/index": [
		325,
		0,
		1,
		2,
		3,
		19
	],
	"./Liquidity/index.tsx": [
		325,
		0,
		1,
		2,
		3,
		19
	],
	"./LiquidityDetail": [
		326,
		0,
		1,
		2,
		7,
		21
	],
	"./LiquidityDetail/": [
		326,
		0,
		1,
		2,
		7,
		21
	],
	"./LiquidityDetail/LiquidityDetail": [
		737,
		0,
		1,
		2,
		7,
		36
	],
	"./LiquidityDetail/LiquidityDetail.hard": [
		777,
		96
	],
	"./LiquidityDetail/LiquidityDetail.hard.tsx": [
		777,
		96
	],
	"./LiquidityDetail/LiquidityDetail.route": [
		452
	],
	"./LiquidityDetail/LiquidityDetail.route.tsx": [
		452
	],
	"./LiquidityDetail/LiquidityDetail.styled": [
		714,
		59
	],
	"./LiquidityDetail/LiquidityDetail.styled.tsx": [
		714,
		59
	],
	"./LiquidityDetail/LiquidityDetail.tsx": [
		737,
		0,
		1,
		2,
		7,
		36
	],
	"./LiquidityDetail/components/Unbind": [
		715,
		0,
		1,
		2,
		7,
		47
	],
	"./LiquidityDetail/components/Unbind.styled": [
		698,
		76
	],
	"./LiquidityDetail/components/Unbind.styled.tsx": [
		698,
		76
	],
	"./LiquidityDetail/components/Unbind.tsx": [
		715,
		0,
		1,
		2,
		7,
		47
	],
	"./LiquidityDetail/index": [
		326,
		0,
		1,
		2,
		7,
		21
	],
	"./LiquidityDetail/index.tsx": [
		326,
		0,
		1,
		2,
		7,
		21
	],
	"./LiquidityPartner": [
		437,
		16,
		30
	],
	"./LiquidityPartner/": [
		437,
		16,
		30
	],
	"./LiquidityPartner/LiquidityPartner": [
		751,
		16
	],
	"./LiquidityPartner/LiquidityPartner.route": [
		453
	],
	"./LiquidityPartner/LiquidityPartner.route.tsx": [
		453
	],
	"./LiquidityPartner/LiquidityPartner.styled": [
		750,
		62
	],
	"./LiquidityPartner/LiquidityPartner.styled.tsx": [
		750,
		62
	],
	"./LiquidityPartner/LiquidityPartner.tsx": [
		751,
		16
	],
	"./LiquidityPartner/index": [
		437,
		16,
		30
	],
	"./LiquidityPartner/index.tsx": [
		437,
		16,
		30
	],
	"./LiquidityPartnerDetail": [
		438,
		17,
		31
	],
	"./LiquidityPartnerDetail/": [
		438,
		17,
		31
	],
	"./LiquidityPartnerDetail/LiquidityPartnerDetail": [
		753,
		17
	],
	"./LiquidityPartnerDetail/LiquidityPartnerDetail.route": [
		454
	],
	"./LiquidityPartnerDetail/LiquidityPartnerDetail.route.tsx": [
		454
	],
	"./LiquidityPartnerDetail/LiquidityPartnerDetail.styled": [
		752,
		83
	],
	"./LiquidityPartnerDetail/LiquidityPartnerDetail.styled.tsx": [
		752,
		83
	],
	"./LiquidityPartnerDetail/LiquidityPartnerDetail.tsx": [
		753,
		17
	],
	"./LiquidityPartnerDetail/index": [
		438,
		17,
		31
	],
	"./LiquidityPartnerDetail/index.tsx": [
		438,
		17,
		31
	],
	"./MainRoute": [
		229
	],
	"./MainRoute/": [
		229
	],
	"./MainRoute/MainRoute": [
		346
	],
	"./MainRoute/MainRoute.enhance": [
		347
	],
	"./MainRoute/MainRoute.enhance.tsx": [
		347
	],
	"./MainRoute/MainRoute.inteface": [
		778,
		97
	],
	"./MainRoute/MainRoute.inteface.ts": [
		778,
		97
	],
	"./MainRoute/MainRoute.tsx": [
		346
	],
	"./MainRoute/index": [
		229
	],
	"./MainRoute/index.ts": [
		229
	],
	"./Profile": [
		439,
		5,
		6,
		26
	],
	"./Profile/": [
		439,
		5,
		6,
		26
	],
	"./Profile/Profile": [
		740,
		5,
		6,
		38
	],
	"./Profile/Profile.hard": [
		690,
		98
	],
	"./Profile/Profile.hard.tsx": [
		690,
		98
	],
	"./Profile/Profile.route": [
		455
	],
	"./Profile/Profile.route.tsx": [
		455
	],
	"./Profile/Profile.styled": [
		734,
		99
	],
	"./Profile/Profile.styled.tsx": [
		734,
		99
	],
	"./Profile/Profile.tsx": [
		740,
		5,
		6,
		38
	],
	"./Profile/components": [
		431,
		5,
		6,
		18
	],
	"./Profile/components/": [
		431,
		5,
		6,
		18
	],
	"./Profile/components/AccountSetting": [
		711,
		5,
		6
	],
	"./Profile/components/AccountSetting.entities": [
		779,
		100
	],
	"./Profile/components/AccountSetting.entities.tsx": [
		779,
		100
	],
	"./Profile/components/AccountSetting.styled": [
		754,
		101
	],
	"./Profile/components/AccountSetting.styled.tsx": [
		754,
		101
	],
	"./Profile/components/AccountSetting.tsx": [
		711,
		5,
		6
	],
	"./Profile/components/ProfileContent": [
		692,
		5,
		6,
		18
	],
	"./Profile/components/ProfileContent.styled": [
		710,
		102
	],
	"./Profile/components/ProfileContent.styled.tsx": [
		710,
		102
	],
	"./Profile/components/ProfileContent.tsx": [
		692,
		5,
		6,
		18
	],
	"./Profile/components/ProfileSibar.entities": [
		780,
		103
	],
	"./Profile/components/ProfileSibar.entities.tsx": [
		780,
		103
	],
	"./Profile/components/ProfileSideBar": [
		687,
		63
	],
	"./Profile/components/ProfileSideBar.styled": [
		691,
		104
	],
	"./Profile/components/ProfileSideBar.styled.tsx": [
		691,
		104
	],
	"./Profile/components/ProfileSideBar.tsx": [
		687,
		63
	],
	"./Profile/components/SocialLink": [
		686,
		84
	],
	"./Profile/components/SocialLink.styled": [
		693,
		105
	],
	"./Profile/components/SocialLink.styled.tsx": [
		693,
		105
	],
	"./Profile/components/SocialLink.tsx": [
		686,
		84
	],
	"./Profile/components/UploadAvatar": [
		755,
		53
	],
	"./Profile/components/UploadAvatar.entities": [
		781,
		106
	],
	"./Profile/components/UploadAvatar.entities.tsx": [
		781,
		106
	],
	"./Profile/components/UploadAvatar.styled": [
		735,
		107
	],
	"./Profile/components/UploadAvatar.styled.tsx": [
		735,
		107
	],
	"./Profile/components/UploadAvatar.tsx": [
		755,
		53
	],
	"./Profile/components/WalletAddress": [
		688,
		54
	],
	"./Profile/components/WalletAddress.hard": [
		695,
		108
	],
	"./Profile/components/WalletAddress.hard.tsx": [
		695,
		108
	],
	"./Profile/components/WalletAddress.styled": [
		694,
		109
	],
	"./Profile/components/WalletAddress.styled.tsx": [
		694,
		109
	],
	"./Profile/components/WalletAddress.tsx": [
		688,
		54
	],
	"./Profile/components/index": [
		431,
		5,
		6,
		18
	],
	"./Profile/components/index.tsx": [
		431,
		5,
		6,
		18
	],
	"./Profile/index": [
		439,
		5,
		6,
		26
	],
	"./Profile/index.tsx": [
		439,
		5,
		6,
		26
	],
	"./Swap": [
		327,
		0,
		10,
		1,
		2,
		20
	],
	"./Swap/": [
		327,
		0,
		10,
		1,
		2,
		20
	],
	"./Swap/Swap": [
		741,
		0,
		10,
		1,
		2,
		35
	],
	"./Swap/Swap.hard": [
		679,
		2
	],
	"./Swap/Swap.hard.tsx": [
		679,
		2
	],
	"./Swap/Swap.route": [
		456
	],
	"./Swap/Swap.route.tsx": [
		456
	],
	"./Swap/Swap.styled": [
		716,
		60
	],
	"./Swap/Swap.styled.tsx": [
		716,
		60
	],
	"./Swap/Swap.tsx": [
		741,
		0,
		10,
		1,
		2,
		35
	],
	"./Swap/Swap.utils": [
		678,
		110
	],
	"./Swap/Swap.utils.tsx": [
		678,
		110
	],
	"./Swap/components/BridgePopUp": [
		684,
		55
	],
	"./Swap/components/BridgePopUp.styled": [
		681,
		111
	],
	"./Swap/components/BridgePopUp.styled.tsx": [
		681,
		111
	],
	"./Swap/components/BridgePopUp.tsx": [
		684,
		55
	],
	"./Swap/components/DropDown": [
		782,
		64
	],
	"./Swap/components/DropDown.styled": [
		756,
		112
	],
	"./Swap/components/DropDown.styled.tsx": [
		756,
		112
	],
	"./Swap/components/DropDown.tsx": [
		782,
		64
	],
	"./Swap/components/SelectToken": [
		689,
		0,
		1,
		2,
		7,
		85
	],
	"./Swap/components/SelectToken.styled": [
		685,
		113
	],
	"./Swap/components/SelectToken.styled.tsx": [
		685,
		113
	],
	"./Swap/components/SelectToken.tsx": [
		689,
		0,
		1,
		2,
		7,
		85
	],
	"./Swap/components/Setting": [
		683,
		61
	],
	"./Swap/components/Setting.styled": [
		680,
		114
	],
	"./Swap/components/Setting.styled.tsx": [
		680,
		114
	],
	"./Swap/components/Setting.tsx": [
		683,
		61
	],
	"./Swap/components/SwapChart": [
		717,
		10,
		86
	],
	"./Swap/components/SwapChart.styled": [
		699,
		115
	],
	"./Swap/components/SwapChart.styled.tsx": [
		699,
		115
	],
	"./Swap/components/SwapChart.tsx": [
		717,
		10,
		86
	],
	"./Swap/index": [
		327,
		0,
		10,
		1,
		2,
		20
	],
	"./Swap/index.tsx": [
		327,
		0,
		10,
		1,
		2,
		20
	],
	"./index": [
		279
	],
	"./index.ts": [
		279
	],
	"./xGalo": [
		440,
		4,
		14,
		32
	],
	"./xGalo/": [
		440,
		4,
		14,
		32
	],
	"./xGalo/index": [
		440,
		4,
		14,
		32
	],
	"./xGalo/index.ts": [
		440,
		4,
		14,
		32
	],
	"./xGalo/xGalo": [
		761,
		4,
		14
	],
	"./xGalo/xGalo.route": [
		457
	],
	"./xGalo/xGalo.route.tsx": [
		457
	],
	"./xGalo/xGalo.styled": [
		757,
		87
	],
	"./xGalo/xGalo.styled.tsx": [
		757,
		87
	],
	"./xGalo/xGalo.tsx": [
		761,
		4,
		14
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 862;
module.exports = webpackAsyncContext;